import { render, staticRenderFns } from "./global-copy-dialog.vue?vue&type=template&id=745afb72&scoped=true&"
import script from "./global-copy-dialog.vue?vue&type=script&lang=js&"
export * from "./global-copy-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745afb72",
  null
  
)

export default component.exports